import { useExperimentsOnlyOptions } from '@neptune/shared/leaderboard-business-logic';

import { useCompareContext } from './use-compare-context';

type CompareIdsForPollingOutput = {
  compareIds: string[];
  enabled?: boolean;
  experimentNamesForPolling?: string[];
  runIdsForPolling?: string[];
};

export function useCompareIdsForPolling(): CompareIdsForPollingOutput {
  const {
    hiddenCount,
    selectedCount,
    filteredAddedRunIdsCount,
    filteredAddedExperimentNamesCount,
    runIds: compareIds,
    showOnlySelectedRuns,
    runIdsReady,
    addedRunIds,
    addedExperimentNames,
    selectedRunIds,
    selectedExperimentNames,
    isTristateEnabled,
  } = useCompareContext();

  const [experimentsOnly] = useExperimentsOnlyOptions();

  const getRunIdsForComparePolling = () => {
    if (experimentsOnly || !showOnlySelectedRuns) {
      return undefined;
    }

    if (isTristateEnabled) {
      return filteredAddedRunIdsCount > 0 ? addedRunIds : undefined;
    }

    return hiddenCount < selectedCount ? selectedRunIds : undefined;
  };

  const getExperimentNamesForComparePolling = () => {
    if (!experimentsOnly || !showOnlySelectedRuns) {
      return undefined;
    }

    if (isTristateEnabled) {
      return filteredAddedExperimentNamesCount > 0 ? addedExperimentNames : undefined;
    }

    return hiddenCount < selectedCount ? selectedExperimentNames : undefined;
  };

  return {
    compareIds,
    enabled: !showOnlySelectedRuns || runIdsReady,
    runIdsForPolling: getRunIdsForComparePolling(),
    experimentNamesForPolling: getExperimentNamesForComparePolling(),
  };
}
